import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import withAuth from '../hoc/withAuth'
import Layout from './ui/layout/layout/Layout'


const PrivateRoute = ({ auth, component: Component, ...rest }) => {
  if (!Object.keys(auth).length) {
    return <Redirect to="/" />
  }

  return <Route {...rest} render={props => <Layout><Component {...props} /></Layout>} />
}

export default withAuth(PrivateRoute)